<template>
  <article
    class="products_and_services"
    id="products_and_services">
    <!-- <div class="products_and_services__filter"></div> -->
    <p class="products_and_services__title">Productos y Servicios</p>
    <transition name="fade">
      <section
        class="products_and_services__services"
        v-if="!filter">
        <div
          class="products_and_services__services--section"
          v-for="(service, index) in services">
          <div
            class="products_and_services__services--icon"
            @click="selected = index; filter = true">
            <img :src="service.icon" alt="">
          </div>
          <p v-html="service.title"></p>
        </div>
      </section>
      <section
        class="products_and_services__filter_services"
        v-else>
        <div class="products_and_services__filter_services--info">
          <div>
            <img :src="services[selected].icon" alt="">
          </div>
          <p v-html="services[selected].title"></p>
          <p v-html="services[selected].text"></p>
        </div>
        <div
          class="products_and_services__filter_services--icons" >
          <div
            class="products_and_services__filter_services--icon products_and_services__services--icon"
            v-for="(service, index) in services"
            @click="selected = index">
            <img :src="service.icon" alt="" >
          </div>
        </div>
      </section>
    </transition>
  </article>
</template>

<script>
export default {
  data(){
    return{
      selected: 0,
      selected_icon: null,
      services:[
        {
          icon: 'https://ippassets.s3.us-east-2.amazonaws.com/graph.svg',
          title: 'Interventoría y Gerencia de Proyectos especializados',
          text: 'Experiencia técnica y manejo de proyectos en áreas de fluidos de perforación, completamiento y workover de pozos petroleros (On Shore - OffShore).'
        },
        {
          icon: 'https://ippassets.s3.us-east-2.amazonaws.com/connection-50.svg',
          title: 'Entrenamiento especializado en fluidos de perforación y completamiento',
          text: 'Capacitaciones en Control de Solidos, Cursos de Fluidos de Perforación, workover y completamiento.<br><br>'+
                ' Conocimiento y desarrollo de nuevas tecnologías en las operaciones en campo.'
        },
        {
          icon: 'https://ippassets.s3.us-east-2.amazonaws.com/tint.svg',
          title: 'Tratamiento de aguas y control de sólidos',
          text: 'Solución integrada del manejo de residuos solidos y líquidos dirigidas a la optimización de los proyectos industriales y de minería.'
        },
        {
          icon: 'https://ippassets.s3.us-east-2.amazonaws.com/lab.svg',
          title: 'Compra y venta de Productos químicos especializados',
          text: 'Adquisición de equipos y productos químicos para la ejecución de proyectos de perforación y completamiento de pozos.'
        },
        {
          icon: 'https://ippassets.s3.us-east-2.amazonaws.com/plus.svg',
          title: 'Otros',
          text: '&#8226; Abastecimiento de agua potable y saneamiento.<br>'+
                '&#8226; Monitoreo y asesoría en control de vertimientos.<br>'+
                '&#8226; Estudios de Impacto Ambiental.<br>'+
                '&#8226; Trámites Ambientales, Permisos, Concesiones.<br>'+
                '&#8226; Auditorias Ambientales.<br>'+
                '&#8226; Análisis Físicoquímico de Agua.<br>'+
                '&#8226; Evaluación y Control de Emisiones Atmosféricas.<br>'+
                '&#8226; Estudios de Monitoreo Ambiental.<br>'+
                '&#8226; Planes de Manejo de Desechos Sólidos y Desechos Peligroso'
        },
      ],
      filter: false
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/shared/ProductsAndServices.vue